export default "__VITE_ASSET__B5zb2km1__"